import { render, staticRenderFns } from "./admin-customfields.vue?vue&type=template&id=684fb9bf"
import script from "./admin-customfields.vue?vue&type=script&lang=js"
export * from "./admin-customfields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports